import slugify from 'slugify';
import {Storyboard} from 'entities/storyboard';
import {getStoryboardTabBasePathFromPath} from './getStoryboardTabBasePathFromPath';

const generateStoryboardUrl = (storyboard: Storyboard, dummyStorySlug: string, storyObject: string): string => {
    const currentPath = window.location.pathname || '';
    const slug = storyboard.slug || slugify(storyboard.title, {lower: true});
    const hashid = storyboard.hashid ?? storyboard.storySlug;

    // 1) Discover → My stories / Shared stories: use path segments, no query params.
    if (currentPath.startsWith('/app/discover/my-stories')) {
        return `/app/discover/my-stories/${hashid}/${slug}`;
    }

    if (currentPath.startsWith('/app/discover/shared-stories')) {
        return `/app/discover/shared-stories/${hashid}/${slug}`;
    }

    // 2) Dashboard / Conversations analytics contexts: keep using base path + query params
    const basePath = getStoryboardTabBasePathFromPath(currentPath, dummyStorySlug);
    if (basePath) {
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set('storyboard', hashid);
        searchParams.set('slug', slug);
        return `${basePath}?${searchParams.toString()}`;
    }

    // 3) Fallback: global insights storyboard route with optional dummy story segments
    let storyUrl = (window.URLS?.storyStoryboardView?.replace('/:storyboard_id/:story_id', '') || '/app/insights/storyboards')
        + `/${hashid}/${slug}`;

    if (dummyStorySlug && storyObject) {
        if (storyUrl.startsWith('/stories/template')) {
            storyUrl = `${storyUrl}/${storyObject}`;
        } else {
            storyUrl = `${storyUrl}/${dummyStorySlug}/${storyObject}`;
        }
    }

    return storyUrl;
};

export default generateStoryboardUrl;
